import { NotifySuccess } from '@/helpers/core/notifications'
import { getWorkOrderChatMessages, sendWorkOrderChatMessage } from '@/services/rc/work-orders.service'
import type { IWorkOrderChatMessageForm } from '@/types/rc/forms'
import type { IFilters } from '@/types/shared/filters'
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'
import { ElMessage } from 'element-plus'

export const useWorkOrderChat = (workOrderNumber: string) => {
  const queryClient = useQueryClient()

  const workOrderChatMessagesQuery = (filters: IFilters) =>
    useQuery({
      queryKey: ['work-order-chat-messages', workOrderNumber, filters],
      queryFn: async () =>
        await getWorkOrderChatMessages(workOrderNumber, filters).finally(() =>
          queryClient.invalidateQueries({ queryKey: ['work-orders', workOrderNumber] })
        ),
    })

  const createWorkOrderChatMessageMutation = useMutation({
    mutationFn: async (form: IWorkOrderChatMessageForm) => await sendWorkOrderChatMessage(workOrderNumber, form),
    onSuccess: () => {
      NotifySuccess(`Message sent successfully.`)
      queryClient.invalidateQueries({ queryKey: ['work-order-chat-messages', workOrderNumber] })
    },
    onError: (e: any) => {
      ElMessage.error(e.message)
    },
  })

  return {
    workOrderChatMessagesQuery,
    createWorkOrderChatMessageMutation,
  }
}
